import { render, staticRenderFns } from "./summary-by-reception-type.vue?vue&type=template&id=60ee3005&"
import script from "./summary-by-reception-type.vue?vue&type=script&lang=js&"
export * from "./summary-by-reception-type.vue?vue&type=script&lang=js&"
import style0 from "./summary-by-reception-type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports